import { render, staticRenderFns } from "./legacy-bullhorn.vue?vue&type=template&id=38d941a3"
import script from "./legacy-bullhorn.vue?vue&type=script&lang=js"
export * from "./legacy-bullhorn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports